import React from "react";
import { createContext, useState } from "react";

export const FlowDetailsContext = createContext();

const FlowDetailsProvider = ({ children }) => {
    const [flowDetails, setFlowDetails] = useState({});
    const [cardData, setCardData] = useState({});

    return <FlowDetailsContext.Provider value={{ flowDetails, setFlowDetails, cardData, setCardData }}>{children}</FlowDetailsContext.Provider>
};

export default FlowDetailsProvider;